// Shared labels/helpers for the Admin Office module (งานธุรการ)

export const UPLOAD_BASE = (process.env.REACT_APP_API || 'http://localhost:3002/api')
  .replace(/\/api\/?$/, '')
  .replace(/\/$/, '')

export const fmtDateTH = (d) =>
  d ? new Date(d).toLocaleDateString('th-TH', { year: 'numeric', month: 'short', day: 'numeric' }) : '-'

export const fmtDateTimeTH = (d) =>
  d ? new Date(d).toLocaleString('th-TH', { year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' }) : '-'

// วันที่ไทยแบบเต็มสำหรับเอกสารราชการ เช่น "11 กรกฎาคม 2569"
export const fmtDateTHFull = (d) =>
  d ? new Date(d).toLocaleDateString('th-TH', { year: 'numeric', month: 'long', day: 'numeric' }) : '-'

export const toBE = (year) => Number(year) + 543
export const toCE = (yearBE) => Number(yearBE) - 543
export const currentBeYear = () => new Date().getFullYear() + 543

// ตัวเลือกปี พ.ศ. สำหรับ dropdown กรองทะเบียน (ปีหน้า..ย้อนหลัง 3 ปี)
export const beYearOptions = () => {
  const y = currentBeYear()
  return [y + 1, y, y - 1, y - 2, y - 3]
}

export const INCOMING_STATUS = {
  pending:      { label: 'รอดำเนินการ', bg: 'warning' },
  forwarded:    { label: 'ส่งต่อแล้ว',   bg: 'info' },
  acknowledged: { label: 'รับทราบแล้ว',  bg: 'primary' },
  done:         { label: 'เสร็จสิ้น',    bg: 'success' },
}

export const OUTGOING_CATEGORIES = [
  'ทั่วไป',
  'ขอความอนุเคราะห์',
  'เชิญวิทยากร',
  'มอบอำนาจ',
  'ส่งเอกสาร',
  'รายงานต้นสังกัด',
]

export const MEMO_STATUS = {
  draft:     { label: 'ฉบับร่าง',        bg: 'secondary' },
  submitted: { label: 'ส่งถึงธุรการ',    bg: 'warning' },
  proposed:  { label: 'เสนอผู้บริหาร',   bg: 'info' },
  approved:  { label: 'อนุมัติ/สั่งการ', bg: 'success' },
  returned:  { label: 'ตีกลับให้แก้ไข',  bg: 'danger' },
  rejected:  { label: 'ไม่อนุมัติ',      bg: 'dark' },
}

export const MEMO_CATEGORIES = [
  'บันทึกข้อความ',
  'ขออนุญาตใช้อาคารสถานที่',
  'ขออนุญาตทั่วไป',
  'ขอความอนุเคราะห์',
  'เชิญวิทยากร',
  'มอบอำนาจ',
  'อื่นๆ',
]

export const ORDER_TYPES = {
  order:        { label: 'คำสั่ง',            bg: 'primary' },
  announcement: { label: 'ประกาศ',            bg: 'info' },
  assignment:   { label: 'มอบหมายหน้าที่',    bg: 'warning' },
  appointment:  { label: 'แต่งตั้งคณะกรรมการ', bg: 'success' },
}

export const ORDER_STATUS = {
  active:    { label: 'ใช้งาน', bg: 'success' },
  cancelled: { label: 'ยกเลิก', bg: 'secondary' },
}

export const MEETING_STATUS = {
  scheduled: { label: 'กำหนดการ',  bg: 'info' },
  done:      { label: 'ประชุมแล้ว', bg: 'success' },
  cancelled: { label: 'ยกเลิก',     bg: 'secondary' },
}

export const RESOLUTION_STATUS = {
  pending:     { label: 'รอดำเนินการ',     bg: 'warning' },
  in_progress: { label: 'กำลังดำเนินการ',  bg: 'info' },
  done:        { label: 'ดำเนินการแล้ว',   bg: 'success' },
}

export const CERT_TYPES = {
  student_status:   { label: 'รับรองสภาพการเป็นนักเรียน', bg: 'primary' },
  student_conduct:  { label: 'รับรองความประพฤติ',          bg: 'info' },
  staff_employment: { label: 'รับรองการทำงาน (บุคลากร)',   bg: 'success' },
}

export const CERT_STATUS = {
  requested: { label: 'รับคำขอ',     bg: 'warning' },
  issued:    { label: 'ออกเอกสารแล้ว', bg: 'success' },
  picked_up: { label: 'รับเอกสารแล้ว', bg: 'secondary' },
}

export const RESOURCE_TYPES = {
  room:    { label: 'ห้องประชุม', bg: 'primary' },
  vehicle: { label: 'รถโรงเรียน', bg: 'warning' },
}

export const BOOKING_STATUS = {
  pending:   { label: 'รออนุมัติ',  bg: 'warning' },
  approved:  { label: 'อนุมัติ',    bg: 'success' },
  rejected:  { label: 'ไม่อนุมัติ', bg: 'danger' },
  cancelled: { label: 'ยกเลิก',     bg: 'secondary' },
}

export const PROJECT_STATUS = {
  planned:     { label: 'เสนอแผน',        bg: 'secondary' },
  approved:    { label: 'อนุมัติแผน',      bg: 'info' },
  in_progress: { label: 'กำลังดำเนินการ', bg: 'primary' },
  done:        { label: 'เสร็จสิ้น',       bg: 'success' },
  cancelled:   { label: 'ยกเลิก',          bg: 'dark' },
}

export const DAILY_LOG_STATUS = {
  draft:     { label: 'ฉบับร่าง',    bg: 'secondary' },
  submitted: { label: 'เสนอ ผอ.',    bg: 'warning' },
  signed:    { label: 'ลงนามแล้ว',   bg: 'success' },
}

// เวลาแบบ HH:MM จากค่า TIME ของ MySQL เช่น "09:00:00" -> "09:00"
export const fmtTime = (t) => {
  if (!t) return '-'
  if (typeof t === 'string') return t.slice(0, 5)
  return new Date(t).toLocaleTimeString('th-TH', { hour: '2-digit', minute: '2-digit' })
}

export const fmtBaht = (n) => {
  const v = parseFloat(n)
  if (Number.isNaN(v)) return '-'
  return v.toLocaleString('th-TH', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
}
